import React from "react";

import t from "../../../lib/translate";
import FormField from "../../../components/form-components/FormField";

export function useSensorBlock() {
    const textFields = (t) => [
        { name: "sCustomer", label: t("form.registration.customer.label"), required: false },
        { name: "sFirstname", label: t("form.registration.firstname.label"), required: true },
        { name: "sLastname", label: t("form.registration.lastname.label"), required: true },
        { name: "sCompany", label: t("form.registration.company.label"), required: true },
        { name: "department", label: t("form.registration.department.label"), required: false },
        { name: "street", label: t("form.registration.street.label"), required: true },
        { name: "number", label: t("form.registration.number.label"), required: true },
        { name: "sCity", label: t("form.registration.city.label"), required: true },
        { name: "zip", label: t("form.registration.zip.label"), required: true },
        { name: "sCountry", label: t("form.registration.country.label"), required: false },
        { name: "sPhone", label: t("form.registration.phone.label"), required: true },
        { name: "sEmail", label: t("form.registration.email.label"), required: true },
    ];

    return <>
        {textFields(t).map(field => <FormField
            type="text"
            key={`sensor-${field.name}`}
            name={field.name}
            label={field.label}
            placeholder={field.label}
            required={field.required}
        />)}
        <FormField
            type="checkbox"
            name="sGdpr"
            label={t("form.registration.gdpr.label")}
            placeholder={t("form.registration.gdpr.label")}
            required
        />
    </>;
}
